// Static data for demo mode - no backend required

// Static vehicles data
export const staticVehicles = [
  {
    id: 1,
    vehicle_name: "Waste Collection Truck #001",
    device_id: "DEV001",
    created_at: "2024-01-15T08:00:00Z"
  },
  {
    id: 2,
    vehicle_name: "Waste Collection Truck #002", 
    device_id: "DEV002",
    created_at: "2024-01-15T08:30:00Z"
  },
  {
    id: 3,
    vehicle_name: "Waste Collection Truck #003",
    device_id: "DEV003", 
    created_at: "2024-01-15T09:00:00Z"
  }
];

// Static vehicles annotation summary
export const staticVehiclesAnnotationSummary = {
  success: true,
  vehicles: [
    {
      vehicle_id: 1,
      vehicle_name: "Waste Collection Truck #001",
      device_id: "DEV001",
      summary: {
        annotation_progress: 75.5,
        annotated_images: 151,
        unprocessed_images: 49,
        total_images: 200
      },
      camera_breakdown: {
        front: { annotated: 50, unprocessed: 20, total: 70 },
        rear: { annotated: 51, unprocessed: 19, total: 70 },
        side: { annotated: 50, unprocessed: 10, total: 60 }
      }
    },
    {
      vehicle_id: 2,
      vehicle_name: "Waste Collection Truck #002",
      device_id: "DEV002", 
      summary: {
        annotation_progress: 60.0,
        annotated_images: 120,
        unprocessed_images: 80,
        total_images: 200
      },
      camera_breakdown: {
        front: { annotated: 40, unprocessed: 30, total: 70 },
        rear: { annotated: 40, unprocessed: 30, total: 70 },
        side: { annotated: 40, unprocessed: 20, total: 60 }
      }
    },
    {
      vehicle_id: 3,
      vehicle_name: "Waste Collection Truck #003",
      device_id: "DEV003",
      summary: {
        annotation_progress: 45.0,
        annotated_images: 90,
        unprocessed_images: 110,
        total_images: 200
      },
      camera_breakdown: {
        front: { annotated: 30, unprocessed: 40, total: 70 },
        rear: { annotated: 30, unprocessed: 40, total: 70 },
        side: { annotated: 30, unprocessed: 30, total: 60 }
      }
    }
  ]
};

// Static unprocessed images data - using local assets
export const staticUnprocessedImages = {
  1: [
    {
      id: 101,
      vehicle_id: 1,
      image_url: '/assets/images/waste_sample_1.jpg',
      signed_url: '/assets/images/waste_sample_1.jpg',
      annotations: [],
      created_at: '2024-01-15T10:30:00Z'
    },
    {
      id: 102,
      vehicle_id: 1,
      image_url: '/assets/images/waste_sample_2.jpg',
      signed_url: '/assets/images/waste_sample_2.jpg',
      annotations: [],
      created_at: '2024-01-15T11:00:00Z'
    },
    {
      id: 103,
      vehicle_id: 1,
      image_url: '/assets/images/waste_sample_3.jpg',
      signed_url: '/assets/images/waste_sample_3.jpg',
      annotations: [],
      created_at: '2024-01-15T11:30:00Z'
    }
  ],
  2: [
    {
      id: 201,
      vehicle_id: 2,
      image_url: '/assets/images/waste_sample_1.jpg',
      signed_url: '/assets/images/waste_sample_1.jpg',
      annotations: [],
      created_at: '2024-01-15T12:00:00Z'
    },
    {
      id: 202,
      vehicle_id: 2,
      image_url: '/assets/images/waste_sample_2.jpg',
      signed_url: '/assets/images/waste_sample_2.jpg',
      annotations: [],
      created_at: '2024-01-15T12:15:00Z'
    }
  ],
  3: [
    {
      id: 301,
      vehicle_id: 3,
      image_url: '/assets/images/waste_sample_3.jpg',
      signed_url: '/assets/images/waste_sample_3.jpg',
      annotations: [],
      created_at: '2024-01-15T12:30:00Z'
    }
  ]
};

// Static timeline data (4AM to 6PM = 840 minutes)
export const generateStaticTimelineData = (vehicleId, date) => {
  const timelineData = [];
  
  // Generate 840 minutes of data (4AM to 6PM)
  for (let i = 0; i < 840; i++) {
    const minute = i + 240; // Start from 4AM (240 minutes)
    
    // Randomly assign video availability (about 60% have video)
    const hasVideo = Math.random() > 0.4;
    
    timelineData.push({
      minute: minute,
      has_video: hasVideo,
      front_video_available: hasVideo && Math.random() > 0.3,
      rear_video_available: hasVideo && Math.random() > 0.3,
      side_video_available: hasVideo && Math.random() > 0.3
    });
  }
  
  return timelineData;
};

// Static GPS trajectory data
export const generateStaticGpsTrajectory = (vehicleId, date) => {
  const trajectory = [];
  const baseLat = 12.9716; // Bangalore latitude
  const baseLng = 77.5946; // Bangalore longitude
  
  // Generate 100 GPS points along a route
  for (let i = 0; i < 100; i++) {
    const lat = baseLat + (Math.random() - 0.5) * 0.01; // Small variation
    const lng = baseLng + (Math.random() - 0.5) * 0.01; // Small variation
    const speed = Math.random() * 50 + 10; // 10-60 km/h
    const heading = Math.random() * 360; // 0-360 degrees
    
    trajectory.push({
      latitude: lat,
      longitude: lng,
      speed: speed,
      heading: heading,
      timestamp: new Date(Date.now() + i * 60000).toISOString() // 1 minute intervals
    });
  }
  
  return trajectory;
};

// Static video details data - using local assets
export const generateStaticVideoDetails = (vehicleId, date, minute) => {
  const videoUrls = {
    left_video_signed: '/assets/videos/sample_video_1.mp4',
    center_video_signed: '/assets/videos/sample_video_2.mp4', 
    right_video_signed: '/assets/videos/sample_video_3.mp4'
  };
  
  const gpsTrajectory = generateStaticGpsTrajectory(vehicleId, date);
  
  return {
    video_urls: videoUrls,
    gps_trajectory: gpsTrajectory,
    video_duration: {
      duration_seconds: 60,
      start_time: new Date(Date.now() - 60000).toISOString(),
      end_time: new Date().toISOString()
    }
  };
};

// Helper functions
export const getStaticVehicles = () => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticVehicles), 500); // Simulate API delay
  });
};

export const getStaticVehiclesAnnotationSummary = () => {
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticVehiclesAnnotationSummary), 500);
  });
};

export const getStaticUnprocessedImages = (vehicleId, limit = 50) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      const images = staticUnprocessedImages[vehicleId] || [];
      resolve(images.slice(0, limit));
    }, 500);
  });
};

export const getStaticTimelineData = (vehicleId, date) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(generateStaticTimelineData(vehicleId, date));
    }, 500);
  });
};

export const getStaticGpsTrajectory = (vehicleId, date) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(generateStaticGpsTrajectory(vehicleId, date));
    }, 500);
  });
};

export const getStaticVideoDetails = (vehicleId, date, minute) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(generateStaticVideoDetails(vehicleId, date, minute));
    }, 500);
  });
};

// Mock API functions that simulate backend responses
export const mockExtractFrame = (frameData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: `Frame extraction requested for ${frameData.camera} camera`,
        frame_id: `frame_${Date.now()}`,
        timestamp: new Date().toISOString()
      });
    }, 1000);
  });
};

export const mockExtractFramesBatch = (frameData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: `Batch frame extraction requested for ${frameData.camera} camera`,
        frame_ids: frameData.video_times.map((_, i) => `frame_${Date.now()}_${i}`),
        timestamp: new Date().toISOString()
      });
    }, 1000);
  });
};

export const mockSaveAnnotation = (annotationData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        success: true,
        message: 'Annotation saved successfully',
        annotation_id: `annotation_${Date.now()}`,
        timestamp: new Date().toISOString()
      });
    }, 1000);
  });
};
